import React from 'react'
import Banner from './Banner'
import TrainingTabs from './TrainingTabs'
import FastTrackSection from './FastTrackSection'
import FastTrackWorkshop from './FastTrackWorkshop'
import LandingPageForm from './LandingPageForm'
import { Helmet } from 'react-helmet-async'

const index = () => {
  return (
    <div>
       <Helmet>
        <title>Real Estate Sales Masterclass | Rajiv Williams</title>
        <meta
          name="description"
          content="Join Rajiv Williams’s sales workshop to close real estate deals faster with proven strategies. Book your seat today!"
        />
        <meta
          name="keywords"
          content="real estate sales workshop, sales training real estate, improve closure rate, real estate sales course, master real estate closings, sales framework workshop, luxury real estate sales coaching, fast track real estate sales training Hyderabad, closing deals faster workshop, Rajiv Williams real estate sales workshop"
        />
        <link rel="canonical" href="https://rajivwilliams.com/fast-track-sales-workshop" />
        <meta property="og:title" content="Real Estate Sales Masterclass | Rajiv Williams" />
        <meta property="og:description" content="Join Rajiv Williams’s sales workshop to close real estate deals faster with proven strategies. Book your seat today!" />
        <meta property="og:url" content="https://rajivwilliams.com/fast-track-sales-workshop" />
        <meta property="og:type" content="website" />
      </Helmet>
      <Banner/>
      <FastTrackWorkshop/>
      <TrainingTabs/>
      <FastTrackSection/>
      <LandingPageForm/>
    </div>
  )
}

export default index
